import React from 'react';
import ReactECharts from 'echarts-for-react';


const WaterLevelGauge = ({
  value,
  tankCapacity,
  gaugeColor = '#0077b6',
  backgroundColor = '#E6E8F7',
  radius = 70,
  center = ['50%', '70%'],
  width = 340,
  height = 250,
  arcTop = '42%',
  textTop = '55%',
}) => {
  return (
    <ReactECharts
      style={{ height, width }}
      option={{
        graphic: [
          {
            type: 'arc',
            left: 'center',
            top: arcTop,
            shape: {
              cx: 0,
              cy: 0,
              r: radius,
              startAngle: Math.PI,
              endAngle: 2 * Math.PI,
            },
            style: {
              fill: backgroundColor,
              stroke: 'none',
              lineCap: 'round',
            },
            z: 1,
          },
          {
            type: 'text',
            left: 'center',
            top: textTop,
            style: {
              text: Math.round(value) + ' %',
              fill: '#3d4346',
              font: '400 18px Avenir, sans-serif',
              textAlign: 'center',
              textVerticalAlign: 'middle',
              letterSpacing: 0.5,
            },
            z: 3,
          },
          {
            type: 'text',
            left: 'center',
            top: '65%',
            style: {
              text: 'Tank Capacity ' + tankCapacity + ' ltr',
              fill: '#3d4346',
              font: '10px Avenir, Segoe UI, Arial, sans-serif',
              textAlign: 'center',
              textVerticalAlign: 'middle',
            },
            z: 3,
          },
        ],
        series: [
          {
            type: 'gauge',
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            radius: '90%',
            center: center,
            axisLine: {
              lineStyle: {
                width: 22,
                color: [
                  [value / 100, gaugeColor],
                  [1, '#e6e8f3'],
                ],
                cap: 'round',
              },
            },
            pointer: { show: false },
            progress: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            anchor: { show: false },
            detail: { show: false },
            data: [{ value }],
          },
        ],
      }}
    />
  );
};

export default WaterLevelGauge;
